import React from 'react'
import { mount } from '../utils/mount'
import { ShopPage } from '../pages/shop-page'

mount('#shop-page-root', <ShopPage />)